import { render, staticRenderFns } from "./key-facts.html?vue&type=template&id=15473b0a&scoped=true&"
import script from "./key-facts.js?vue&type=script&lang=js&"
export * from "./key-facts.js?vue&type=script&lang=js&"
import style0 from "./key-facts.scss?vue&type=style&index=0&id=15473b0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15473b0a",
  null
  
)

export default component.exports